export const buildUrl = (slug, page) => {
  let url = '/';

  if (page) {
    if (page.internal && page.internal.type) {
      if (page.internal.type === 'DatoCmsPage' && page.treeParent) {
        if (
          page.treeParent.treeParent &&
          page.treeParent.treeParent.treeParent
        ) {
          url += `${page.treeParent.treeParent.treeParent.slug}/`;
        }

        if (page.treeParent.treeParent) {
          url += `${page.treeParent.treeParent.slug}/`;
        }

        url += `${page.treeParent.slug}/`;
      } else if (page.internal.type === 'ShopifyProduct') {
        const shortestCollectionHandle =
          page.collections.length > 0
            ? page.collections.reduce((a, b) =>
                a.handle.length < b.handle.length ? a : b,
              ).handle
            : null;

        if (shortestCollectionHandle) {
          url += `${shortestCollectionHandle}/`;
        }
      } else if (page.internal.type === 'DatoCmsBlog') {
        url += 'blog/';
      } else if (page.internal.type === 'DatoCmsAdviceGuideCategory') {
        url += 'advice-guides/';
      } else if (page.internal.type === 'DatoCmsEvent') {
        url += 'exhibition-calendar/';
      } else if (page.internal.type === 'DatoCmsEventVenue') {
        url += 'venue/';
      }
    }
  }

  url += `${slug !== '/' ? `${slug.replace(/^\/|\/$/g, '')}/` : ''}`;

  return url;
};
